import SequencerBase from 'es6/controllers/apps/sequencer-base';

export default class SentenceTrainerSequencer extends SequencerBase {
  constructor(sessionData) {
    super(sessionData.studySession, false, null);
  }

  /**
   * @override
   */
  showNextQuiz() {
    const itemsWithQuizzesRemaining = this._itemsWithQuizzesRemaining();

    if (itemsWithQuizzesRemaining.length > 0) {
      this._showNextQuizForItem(itemsWithQuizzesRemaining[0]);
    } else {
      this.sequenceFinished();
    }
  }

  /**
   * @override
   */
  quizFinished(quiz) {
    const studyItem = this._studyItemFromQuiz(quiz);
    studyItem.sequencing.presentedQuizzes.push(quiz);
    this._incrementProgress();
    this.showNextQuiz();
  }

  /**
   * Updates the progress.
   *
   * @override
   */
  _incrementProgress() {
    const progress = this._studyItems.length - this._itemsWithQuizzesRemaining().length;
    this._updateProgress(progress);
  }
}
